import {useTranslationContext} from 'platform/components';
import {Icon} from 'platform/foundation';

import type {TestIdProps} from 'shared/web';

type PresetSelectionIndicatorProps = TestIdProps & {
  active: boolean;
};

export function PresetSelectionIndicator(props: PresetSelectionIndicatorProps) {
  const t = useTranslationContext();

  return (
    <span
      role="img"
      aria-label={props.active ? t('general.labels.active') : undefined}
      aria-hidden={!props.active || undefined}
      className="inline-flex shrink-0 text-inherit"
      data-testid={props['data-testid']}
    >
      <span aria-hidden className="flex">
        <Icon
          value={props.active ? 'action/check_circle' : 'toggle/radio_button_unchecked'}
          color={props.active ? undefined : 'text.secondary'}
          size={5}
        />
      </span>
    </span>
  );
}
